import { BehaviorSubject } from 'rxjs';

const stateFromNative$ = new BehaviorSubject({});
window.perpayStateFromNative$ = stateFromNative$;

// Generate a string to pass to injectJavaScript that will pass the state to the
// perpayStateFromNative$ Observable to transmit actions from native to fintech.
export function getSerializedStateInjectionString(serializedState) {
    return `window.perpayStateFromNative$.next(${serializedState});`;
}

export function getStateFromNative() {
    return window.perpayStateFromNative$;
}
